import {PaymentFromTransaction} from "@/model/PaymentFromTransaction";
import {InvoicePaymentResponse} from "@/types/service-response";

export class InvoicePayment {
  private constructor (
    readonly id: number,
    readonly createdAt: string,
    readonly sourceKind: string,
    readonly receivedAt: string,
    readonly amount: number,
    readonly paymentsFromTransaction: PaymentFromTransaction[],
    readonly paymentsFromWallet: string[]

  ) {}

  static createFromResponse (responseData: InvoicePaymentResponse[]): InvoicePayment[] {
    return responseData.map((item: InvoicePaymentResponse) => {
      return new InvoicePayment(
          item.id,
          item.createdAt,
          item.sourceKind,
          item.receivedAt,
          item.amount,
          PaymentFromTransaction.createFromResponse(item.paymentsFromTransaction),
          item.paymentsFromWallet
      )
    })
  }
}
